import * as Dialog from "@radix-ui/react-dialog";
import * as React from "react";
import Icon from "@components/icon";

interface DiaglogProps {
  trigger: React.ReactNode;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  open?: boolean;
  closeButtonTop?: boolean;
  onOpenChange?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RadixDialog = ({
  trigger,
  title,
  description,
  children,
  ...props
}: DiaglogProps) => (
  <Dialog.Root {...props}>
    <Dialog.Trigger className="w-full focus:ring-0 focus-visible:ring-0 focus-within:outline-none active:ring-0">
      {trigger}
    </Dialog.Trigger>

    <Dialog.Portal>
      <Dialog.Overlay className="w-screen h-screen grid place-items-center bg-black/30 !z-[2147483646] fixed top-0 overlay-animate">
        <Dialog.Content
          className={`${
            props.closeButtonTop
              ? "bg-transparent w-screen h-screen"
              : "bg-white w-[90%] max-w-[35rem]"
          } rounded-md p-6 border border-inawo-green/5 relative  overlay-content-animate`}
        >
          <Dialog.Close
            className={`${
              props.closeButtonTop ? "fixed" : "absolute"
            } top-5 right-5 p-1.5 rounded-md transition bg-white z-[5] hover:bg-gray-200 cursor-pointer`}
          >
            <Icon iconName="close" />
          </Dialog.Close>
          {title && <Dialog.Title>{title}</Dialog.Title>}
          {description && <Dialog.Description></Dialog.Description>}
          {children}
        </Dialog.Content>
      </Dialog.Overlay>
    </Dialog.Portal>
  </Dialog.Root>
);

export default RadixDialog;
